export default __webpack_public_path__ + "static/media/launcher-macos.a0bf54e2.png";